module.exports = __webpack_public_path__ + "img/loaded.3611a96c.png";